import { render } from "./EventDashboard.vue?vue&type=template&id=587d184e&scoped=true"
import script from "./EventDashboard.vue?vue&type=script&lang=js"
export * from "./EventDashboard.vue?vue&type=script&lang=js"

import "./EventDashboard.vue?vue&type=style&index=0&id=587d184e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587d184e"]])

export default __exports__